




























import { Component, Vue } from "vue-property-decorator";
import AuditTabPane from "../components/AuditTabPane.vue";
import api from "@/api";
// import {AuditUserLogType} from "@/api/appService";

@Component({
  name: "AuditTabOfExternalProjectProgressReport",
  components: { AuditTabPane },
})
export default class AuditTabOfExternalProjectProgressReport extends Vue {
  get fetchData() {
    return api.externalProjectProcessReport.getMyAll;
  }

  handleAudit(dto: any) {
    return this.$router.push({
      name: "externalProject-progressReports-detail",
      params: { id: dto.id!.toString() },
    });
  }

  handleCountChange(value: number) {
    this.$emit("count-changed", value);
  }
}
